import { render, staticRenderFns } from "./ReferrersReport.vue?vue&type=template&id=a5d5517c&scoped=true"
import script from "./ReferrersReport.vue?vue&type=script&lang=js"
export * from "./ReferrersReport.vue?vue&type=script&lang=js"
import style0 from "./ReferrersReport.vue?vue&type=style&index=0&id=a5d5517c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d5517c",
  null
  
)

export default component.exports